import React from 'react';
import { motion } from 'framer-motion';

import { AppWrap } from '../../wrapper';

import './Header.scss';

const Header = () => {
  return (
    <div className='app__header app__flex'>

    <svg className='animation__circle' viewBox="0 0 1024 1023" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="animation-circle">
        <circle id="circle" cx="512" cy="511" r="495" stroke="url(#paint0_linear_139_258)" stroke-width="2"/>
      <g id="circles">
        <circle id="circle_2" cx="17.5176" cy="511.5" r="10" fill="url(#paint1_linear_139_258)"/>
        <circle id="circle_3" cx="1006.48" cy="511.5" r="10" fill="url(#paint2_linear_139_258)"/>
      </g>
      </g>
      <defs>
        <linearGradient id="paint0_linear_139_258" x1="512" y1="246.755" x2="55.9467" y2="1022.24" gradientUnits="userSpaceOnUse">
        <stop offset="0.0736284" stop-color="#344675"/>
        <stop offset="0.756253" stop-color="#263148"/>
        </linearGradient>
        <linearGradient id="paint1_linear_139_258" x1="17.5176" y1="502.47" x2="1.9334" y2="528.97" gradientUnits="userSpaceOnUse">
        <stop offset="0.0736284" stop-color="#344675"/>
        <stop offset="0.756253" stop-color="#263148"/>
        </linearGradient>
        <linearGradient id="paint2_linear_139_258" x1="1006.48" y1="502.47" x2="990.898" y2="528.97" gradientUnits="userSpaceOnUse">
        <stop offset="0.0736284" stop-color="#344675"/>
        <stop offset="0.756253" stop-color="#263148"/>
        </linearGradient>
      </defs>
    </svg>

      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1]}}
        transition={{ duration: 0.5 }}
        className='app__header-info'
      >
        <div className='app__header-intro'>

            <p className='head-text'>Hi, my <br />name is <span className='orange-gradient'>Lucija</span>.</p>
            <p className='intro-text p-text'>Welcome to my little slice of the Internet - I hope you find something useful here.
            I <span className='bold-text-intro'>design Interfaces, build Websites, create Content</span>, and work as a <span className='bold-text-intro'>Graphic Designer</span>.
            <br />
            <br />
            Thanks for dropping by, Lucija
            </p>
            <a href='#work' className="btn btn-orange">My Portfolio</a>

        </div>

      </motion.div>

    </div>
  );
}

export default AppWrap(Header, 'home');
